import {currentBrowser, createEventListener, in_array} from "./tools";
import $ from "jquery";
import storage from "./storage";

export default function($app) {
	const $locale = $app.require('locale');

	this.isEnabled = ko.computed(() =>
		!storage.get('hideGuide')
		&& !currentBrowser.isMobile()
		&& !in_array($app.event().client().id(), [2,21,122,65,97,137,721])
	);

	$app.on('start', () => {
		if(this.isEnabled()) {
			setTimeout(() => {
				const guide = this.guide = new Guide({
					buttons: {
						next: $locale.get('guide.next'),
						prev: $locale.get('guide.prev'),
						exit: $locale.get('guide.exit')
					}
				});
				guide.on('stop', () => storage.set('hideGuide', true, storage.DAY * 365));

				if($app.event().episode().length) {
					if ($app.event().moduleEpisode.showTable()) {
						guide.push('#episodeTable .episode:first-child', $locale.get('guide.viewRecordClick'), {padding: 10, radius: 5})
							.on('beforeShow', () => $app.require('episodeTable').show())
							.on('hide', () => $app.require('episodeTable').hide())
						;
						guide.push(`.tabsContentContainer .episode-list`, $locale.get('guide.viewRecordOnSidebar'))
						//.on('beforeShow', () => $app.require('episode').show())
						;
					} else if ($app.require('episode').isEnabled()) {
						guide.push(`.tabsContainer li > a.icon-episode`, $locale.get('guide.episodeList'), {padding: 10, radius: 5});
					}

					guide.push('.tabsContainer li > a.icon-search', $locale.get('guide.find'), {padding: 10, radius: 5});

					if($app.require('episodeFavorite').isEnabled()) {
						guide.push('.tabsContainer li > a.icon-episodeFavorite', $locale.get('guide.favorite'), {padding: 10, radius: 5});
					}

					if($app.event().stream().length > 1) {
						switch ($app.event().status()) {
							case 'stop': guide.push('.tabsContainer li a.icon-table', $locale.get('guide.viewRecord'), {padding: 10, radius: 5}); break;
							default: guide.push('.tabsContainer li a.icon-table', $locale.get('guide.viewSchedule'), {padding: 10, radius: 5}); break;
						}
					}
				}

				const modules = {
					information: $locale.get('guide.information'),
					comment: $locale.get('guide.comment'),
					question: $locale.get('guide.question'),
				};
				Object.keys(modules).forEach(module => {
					if ($app.require(module).isEnabled()) {
						guide.push($(`.tabsContainer li > a.icon-${module}`).parent(), modules[module], {padding: 10, radius: 5});
					}
				});

				if ($app.event().moduleBranding.share() && !$app.event().private()) {
					guide.push('.icon-share:visible', $locale.get('guide.shareIcon'), {padding: 10, shape: 'circle'})
						.on('beforeShow', () => $app.require('player').getToolBar().visible(true))
						.on('hide', () => $app.require('player').getToolBar().visible(false))
					;
					guide.push('#shareContainer', $locale.get('guide.shareButton'), {padding: 10, radius: 5})
						.on('beforeShow', () => $app.require('share').show())
						.on('hide', () => $app.require('share').hide())
					;
				}

				// if ($app.event().status() === 'stop') {
				// 	guide.push('.player-play-button', 'Для начала просмотра нажмите кнопку "Старт"', {shape: 'circle', padding: 10});
				// }

				guide.push(null, $locale.get('guide.final'), {buttons: {prev: false}});

				guide.start();
			}, 1000);
		}
	});
};

function Guide(options) {
	const controlsAnimateTime = 500;
	const boxAnimateTime = 500;
	let currentStepIndex = -1;
	const steps = [];
	this.steps = steps;
	options = Object.assign({},{buttons:{exit:"Выход",prev:"Назад",next:"Далее"}},options);

	const elements = {
		container: $('<div>').appendTo(document.body).addClass('hint-guide')
	};
	elements.top = $('<div>').appendTo(elements.container).addClass('hint-guide-overlay hint-guide-overlay-top');
	elements.middle = $('<div>').appendTo(elements.container).addClass('hint-guide-overlay hint-guide-overlay-middle');
	elements.bottom = $('<div>').appendTo(elements.container).addClass('hint-guide-overlay hint-guide-overlay-bottom');
	elements.left = $('<div>').appendTo(elements.middle).addClass('hint-guide-overlay hint-guide-overlay-left');
	elements.center = $('<div>').appendTo(elements.middle).addClass('hint-guide-overlay hint-guide-overlay-center');
	elements.right = $('<div>').appendTo(elements.middle).addClass('hint-guide-overlay hint-guide-overlay-right');
	elements.centerCircle = $('<div>').appendTo(elements.center);

	elements.info = {
		container: $('<div>').appendTo(elements.container).addClass('hint-guide-info')
	};
	elements.text = $('<div>').appendTo(elements.info.container).addClass('hint-guide-text');
	elements.buttons = {};
	elements.buttons.container = $('<div>').appendTo(elements.info.container).addClass('hint-guide-buttons');
	elements.buttons.exit = $('<button>').appendTo(elements.buttons.container).text(options.buttons.exit).on('click', () => this.stop()).addClass('button-close');
	elements.buttons.prev = $('<button>').appendTo(elements.buttons.container).text(options.buttons.prev).on('click', () => this.prevStep());
	elements.buttons.next = $('<button>').appendTo(elements.buttons.container).text(options.buttons.next).on('click', () => this.nextStep());

	let containerSize = {};

	createEventListener(this);

	this.push = (selector, text, options) => {
		const step = new Step(selector, text, options);
		steps.push(step);
		return step;
	};

	this.start = () => {
		elements.container.show().css({opacity: 1});
		this.setStep(0);
//		setTimeout(function() { setStep(1); }, 2000);
		this.trigger('start');
		return this;
	};

	this.stop = () => {
		elements.container.css({opacity: 0});
		setTimeout(() => {
			elements.container.hide();
			elements.top.css({height: 0});
			elements.middle.css({height: '100%'});
			elements.bottom.css({height: 0});
			elements.left.css({width: 0});
			elements.center.css({width: '100%', left: 0});
			elements.right.css({width: 0});
			elements.centerCircle.css({borderRadius: 0});
			hideInfo();
		}, 500);
		this.trigger('stop');
		return this;
	};

	this.nextStep = () => {
		this.setStep(currentStepIndex+1);
		this.trigger('next');
		return this;
	};
	this.prevStep = () => {
		this.setStep(currentStepIndex-1);
		this.trigger('prev');
		return this;
	};

	this.setStep = index => {
		const currentStep = steps[currentStepIndex];
		const nextStep = steps[index];

		if(currentStep) {
			currentStep.trigger('hide');
			this.trigger('hide', currentStep);
		}
		if(nextStep) {
			currentStepIndex = index;
			nextStep.trigger('beforeShow');
			setTimeout(() => {
				setStep(nextStep);
				nextStep.trigger('show');
				this.trigger('show', nextStep);
			}, 0);
		} else {
			this.stop();
			currentStepIndex = -1;
		}

		return this;
	};

	function hideInfo() {
		return new Promise(resolve => {
			const isAnimate = elements.buttons.container.is(':visible');
			elements.buttons.container.css({opacity: 0});
			elements.text.css({opacity: 0});
			setTimeout(() => resolve(), isAnimate ? controlsAnimateTime : 0);
		});
	}

	function showInfo() {
		return new Promise(resolve => {
			const isAnimate = elements.buttons.container.is(':visible');
			elements.buttons.container.css({opacity: 1});
			elements.text.css({opacity: 1});
			setTimeout(() => resolve(), isAnimate ? controlsAnimateTime : 0);
		});
	}

	function moveBox(box) {
		return new Promise(resolve => {
			elements.top.css({height: box.top});
			elements.middle.css({height: box.height});
			elements.bottom.css({height: containerSize.height - box.top - box.height});

			elements.left.css({width: box.left});
			elements.center.css({width: box.width, left: box.left});
			elements.right.css({width: containerSize.width - box.left - box.width});

			setTimeout(() => resolve(), boxAnimateTime);
		});
	}

	function moveInfo() {
		const boxRectangle = {
			left: elements.left.width(),
			top: elements.top.height(),
			width: elements.center.width(),
			height: elements.center.height()
		};
		const boxRectangleCenter = {
			left: boxRectangle.left + boxRectangle.width / 2,
			top: boxRectangle.top + boxRectangle.height / 2
		};
		const infoSize = {
			width: elements.info.container.outerWidth(),
			height: elements.info.container.outerHeight()
		};

		const textPosition = {};

		if(boxRectangle.top + boxRectangle.height / 2 < containerSize.height * .5) { // top
			textPosition.top = boxRectangle.top + boxRectangle.height;
		} else { // bottom
			textPosition.top = boxRectangle.top - infoSize.height;
		}

		if((textPosition.top < 0) || (textPosition.bottom > containerSize.height)) {
			textPosition.top = boxRectangleCenter.top - infoSize.height/2;

			if(boxRectangleCenter.left > containerSize.width/2) { // right
				textPosition.left = boxRectangle.left - infoSize.width;
			} else { // left
				textPosition.left = boxRectangle.left + boxRectangle.width;
			}
		} else {
			textPosition.left = boxRectangleCenter.left - infoSize.width / 2;
			if (textPosition.left < 0) {
				textPosition.left = 0;
			} else if (textPosition.left + infoSize.width > containerSize.width) {
				textPosition.left = containerSize.width - infoSize.width;
			}
		}

		elements.info.container.css(textPosition);
	}

	function setStep(step) {
		const selector = !step.selector || 'string' === typeof step.selector || !step.selector.jquery ? $(step.selector) : step.selector;
		const padding = step.options && step.options.padding || 0;
		let box;

		containerSize = {
			width: elements.container.width(),
			height: elements.container.height()
		};

		if(selector.length) {
			box = {
				left: selector.offset().left - padding,
				top: selector.offset().top - padding,
				width: selector.outerWidth() + padding*2,
				height: selector.outerHeight() + padding*2
			};
		} else {
			box = {
				left: containerSize.width/2,
				top: containerSize.height/2,
				width: 0,
				height: 0
			};
		}

		hideInfo()
			.then(() => {
				const stepIndex = steps.indexOf(step);
				elements.text.css({left: 0, top: 0}).text(step.text);
				elements.buttons.prev.toggle(!!steps[stepIndex-1] && (!step.options.buttons || step.options.buttons.prev));
				elements.buttons.next.toggle(!!steps[stepIndex+1] && (!step.options.buttons || step.options.buttons.next));
			})
			.then(() => {
				let radius = 0;
				if(!isNaN(step.options.radius)) {
					radius = step.options.radius;
				} else if(step.options.shape === 'circle') {
					radius = Math.max(box.width, box.height);
				}
				elements.centerCircle.css({borderRadius: radius + 200});
				return moveBox(box);
			})
			.then(moveInfo)
			.then(showInfo)
		;
	}

	function Step(selector, text, options) {
		this.selector = selector;
		this.options = options || {};
		this.text = text;

		createEventListener(this);
	}

}
